import { render, staticRenderFns } from "./PopperTooltip.vue?vue&type=template&id=610bd322"
import script from "./PopperTooltip.vue?vue&type=script&lang=js"
export * from "./PopperTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports